module.exports = __webpack_public_path__ + "assets/img/paperwalletinstructions.5c27f97ea442e0b0826e6e320f0cf2ce.svg";